/**
 * @module flipCard
 */
(function FlipCard () {

    function FlipCard ($dom) {
        /**
         * // local object availability
         * @type {FlipCard}
         * @private
         */
        var _this = this;

        /**
         * @type {element(s)}
         */
        this.$dom = $dom;

        /**
         * @type {object}
         */
        this.options = {
            rootMargin: '0px',
            threshold: 0.5 // 0 to 1.0
        };

        /**
         * @method onIntersect
         * @returns {undefined}
         */
        this.onIntersect = function(entries){
            entries.forEach(function (entry){
                var target =  entry.target;
                var isIntersecting = entry.isIntersecting;

                if (isIntersecting) {
                    $(target).addClass('js__is-scroll-into-viewport-flipped');
                }
            });
        };

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            // Instantiate IntersectionObserver
            this.observer = new IntersectionObserver(this.onIntersect, this.options);

            // Observing
            this.$dom.each(function (index, element){
                _this.observer.observe(element);
            });

            // Click event on touch devices
            this.$dom.each(function (index, element){
                $(element).on('click', function(e) {
                    let device = $('html')[0].dataset.device;

                    // Only touch devices
                    if (device === 'touch') {
                        // Reset all flip card
                        _this.$dom.each(function() {
                            $(this).removeClass('js__touch-device-clicked');
                            $(this).removeClass('is-active');
                        });

                        // Flip clicked card to back side.
                        $(this).toggleClass('js__touch-device-clicked');
                        let _that = this;
                        setTimeout(function () {
                            $(_that).addClass('is-active');
                        },1000)
                    }
                });
            });


        };

        /**
         * initialize call
         */
        _this.init();
    }


    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }

    window.Juzo.FlipCard = FlipCard;
}) ();


$ (document).ready (function () {
    var $boxes = $('[data-hook-flip-card="flip-card"]');
    if ($boxes.length) {
        new window.Juzo.FlipCard($boxes);
    }
});